<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        編輯資產交還單
      </h1>
    </div>
    <div class="info_wrap col">
      <!-- 申請人員，申請日期 -->
      <div class="fixed_info">
        <p>申請資訊</p>
      </div>
      <div class="content">
        <!-- 單號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              單號：
            </div>
            <div class="form-control readonly_box">{{ Form.RR_ID }}</div>
          </div>
        </div>
        <!-- 接收人員 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              接收人員：
            </div>
            <div class="form-control readonly_box">{{ Form.ReturnPersonName }}</div>
          </div>
        </div>
        <!-- 交還日期 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              交還日期：
            </div>
            <div class="form-control readonly_box">{{ Form.ReturnDate }}</div>
          </div>
        </div>
        <!-- 交還人員 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              <span>*</span>交還人員：
            </div>
            <select class="form-select" v-model="Form.Custodian" @change="searchAssetList">
              <option value="">--請選擇--</option>
              <option v-for="option in DropdownArray.Staff" :value="option.Value">{{ option.Text }}</option>
            </select>
          </div>
        </div>
        <!-- 交還原因 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend"><span>*</span>交還原因：</div>
            <select class="form-select" v-model="Form.Reason">
              <option value="">--請選擇--</option>
              <option v-for="option in DropdownArray.Reason" :value="option">{{ option }}</option>
            </select>
          </div>
        </div>
        <!-- 備註 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">
              備註：
            </div>
            <textarea style="height: 200px;" class="form-control" placeholder="最多輸入500字" maxlength="500"
              v-model="Form.Memo"></textarea>
          </div>
        </div>
        <!-- 交還文件上傳 -->
        <div class="col-12 repair_photo_section">
          <div class="input-group mt-3">
            <div class="input-group-prepend">交還文件上傳：</div>
            <div class="mb-3 file_wrap">
              <button class="choose_btn" @click="fileInputs.click()">選擇檔案</button>
              <input type="file" ref="fileInputs" accept="image/*, .pdf" multiple style="display: none;"
                @change="utilsStore.handleDocumentChange($event, Form)">
            </div>
          </div>
        </div>
        <!-- 已選擇的文件 -->
        <div class="col-12 selected_file">
          <div class="input-group">
            <div class="input-group-prepend">已選擇的文件：</div>
            <div class="file_upload_box">
              <div v-for="(file, index) in Form.viewDocument" :key="index" class="file_upload_wrap mb-1">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)">
                  <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                    @click="utilsStore.deleteDocumentFile('new', Form, index)">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 已上傳文件 -->
        <div class="col-12 selected_file">
          <div class="input-group mt-3">
            <div class="input-group-prepend">已上傳文件：</div>
            <div class="file_upload_box">
              <div v-for="(file, index) in Form.existDocument" :key="index" class="file_upload_wrap mb-1">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)">
                  <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                    @click="utilsStore.deleteDocumentFile('exist', Form, index)">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fixed_info mt-4">
        <p>資產點交清冊</p>
      </div>
      <div class="content">
        <asset_list_datagrid v-model="dgModel"></asset_list_datagrid>
      </div>
      <div class="col button_wrap">
        <button class="back_btn" @click="utilsStore.goBack">回上一頁</button>
        <button class="send_btn" @click="returnAssetStore.submit('edit', dgModel)">送出</button>
      </div>
    </div>
  </div>
  <view_modal></view_modal>
  <button type="button" id="openModal" data-bs-toggle="modal" data-bs-target="#viewFile_modal"
  style="display:none;">開啟modal隱藏按鈕</button>
</template>

<script setup>
import view_modal from '@/components/view_modal.vue';
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import asset_list_datagrid from '@/components/return_asset_page/asset_list_datagrid.vue';
import { useAPIStore, useUtilsStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useReturnAssetStore } from '@/store/return_asset/_index';
import { Return_Asset_Edit } from '@/assets/js/enter_status';
import { useRoute } from 'vue-router';
const utilsStore = useUtilsStore();
const returnAssetStore = useReturnAssetStore();
const apiStore = useAPIStore();
const route = useRoute();
const RR_ID = route.query.search_id

const {
  Form,
  DropdownArray,
} = storeToRefs(returnAssetStore);
const originalCustodian = ref('');
const dgModel = reactive({
  dgRowData: [],
  selectedList: [],
})
const fileInputs = ref(null); // dom ref
const searchAssetList = async () => {
  dgModel.dgRowData = [];
  dgModel.selectedList = [];
  if ((originalCustodian.value === Form.value.Custodian) && (Form.value.TotalNum > 200)) {
    const count = Math.ceil(Form.value.TotalNum / 200);
    for (let i = 1; i <= count; i++) {
      let assetData = await returnAssetStore.getCustodianAssetList(Form.value.Custodian, RR_ID, false, '200', i);
      dgModel.dgRowData.push(assetData);
    }
  } else {
    dgModel.dgRowData = await returnAssetStore.getCustodianAssetList(Form.value.Custodian, RR_ID);
  }
  dgModel.dgRowData.forEach((item) => {
    if (item.IsReturn) dgModel.selectedList.push(item);
  })
}
onMounted(async () => {
  returnAssetStore.$reset();
  DropdownArray.value.Staff = await apiStore.getUserNickName('', true);
  await returnAssetStore.getDetails(RR_ID, Return_Asset_Edit);
  originalCustodian.value = Form.value.Custodian;
  searchAssetList();
});
onUnmounted(() => {
  returnAssetStore.$dispose();
})

</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.view_icon,
.trash_icon {
  cursor: pointer;
}

.modal {
  .modal-body {
    padding: 20px;
    margin: auto;
  }

  .modal-content {
    margin: auto;
  }

  .modal-input-group-prepend {
    width: auto;
    font-weight: 700;
    font-size: 20px;
  }

  .modal-footer {
    padding: 0 12px 12px;
    border: none;
  }

  .modal-header {
    h5 {
      font-weight: 700;
    }

    background: #528091;
    color: white;
    display: flex;
    justify-content: center;
  }
}

.readonly_box {
  @include readonly_box;
}

.form_search_btn {
  @include form_search_btn;
}

.input-number {
  @include count_btn;
}

span {
  @include red_star;
}

.main_section {
  .info_wrap {
    .fixed_info {
      @include fixed_info;

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .content {
      @include content_bg;

      .input-group {

        .form-control,
        .readonly_box {
          height: 37px;
          border-radius: 0;
        }

        .input-group-prepend {
          color: white;
          font-weight: 700;
          font-size: 20px;
          width: 140px;
        }

        .file_wrap {
          display: flex;
          flex-direction: column;

          .choose_btn {
            margin-bottom: 10px;
            @include choose_file_btn;

            &:hover {
              background: #3f608f;
            }
          }
        }
      }
    }

    .selected_file {
      .file_upload_box {
        .file_upload_wrap {
          margin-bottom: 0;
          display: flex;
          word-break: break-word;

          img {
            width: 25px;
            height: 25px;
          }

          p {
            margin-bottom: 0;
            font-weight: 700;
            color: white;

            &::before {
              margin-right: 10px;
              content: "·";
              font-weight: 700;
              color: white;
            }
          }
        }
      }
    }
  }
}

.button_wrap {
  display: flex;
  justify-content: space-between;
  margin: 30px auto 5%;
  width: 210px;

  .back_btn {
    @include back_to_previous_btn;

    &:hover {
      background-color: #5d85bb;
    }
  }
}

.send_btn {
  @include search_and_send_btn;

  &:hover {
    background-color: #5e7aa2;
  }
}

.send_btn_disabled {
  background: #878787;

  &:hover {
    background: #878787;
  }
}

@media only screen and (min-width: 1200px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 800px;

      .content {
        .input-group {
          .input-group-prepend {
            text-align: end;
            width: 140px;
          }
        }
      }

      .selected_file {
        .input-group {
          flex-wrap: unset;
        }

        .input-group-prepend {
          white-space: nowrap;
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 750px;

      .content {
        .input-group {

          .readonly_box,
          .input-number {
            width: 100%;
          }

          .form-control {
            width: 65%;
          }

          .input-group-prepend {
            text-align: end;
            width: 140px;
          }
        }
      }

      .selected_file {
        .input-group {
          flex-wrap: unset;
        }

        .input-group-prepend {
          white-space: nowrap;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {

    .readonly_box,
    .input-number,
    .form-control,
    .file_wrap {
      margin-left: unset !important;
    }

    .form_search_btn {
      border: none;
      color: white;
      width: 60px;
      height: 35px;
      margin-left: unset !important;
      margin-top: 10px;
      font-weight: 700;
      padding: 0 10px;
      background-color: #132238;

      &:hover {
        background-color: #43546d;
      }
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;
      }

      .content {
        .input-group {
          flex-direction: column;

          .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin-left: unset;
            border-radius: 5px;
            margin-top: 5px;
            height: 35px;
          }

          .form-control {
            width: 100%;
          }

          .input-group-prepend {
            margin-bottom: 5px;
            width: 100px;
            white-space: nowrap;
          }

          .file_wrap {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>